import clsx from "clsx";
import { TruncatedTextTooltip } from "components/common/TruncatedTextTooltip";
import type { PlanNameChipProps } from "./types";

export const PlanNameChip = ({ name, variant }: PlanNameChipProps) => (
  <code
    className={clsx(
      "block min-w-0 max-w-full rounded border px-1.5 py-0.5 font-mono text-xs text-gray-700",
      variant === "outlined"
        ? "border-gray-200 bg-white"
        : "border-gray-200 bg-gray-50",
    )}
  >
    <TruncatedTextTooltip text={name} className="block" />
  </code>
);
